module.exports = __webpack_public_path__ + "static/media/SlidesVideoNALAS.ebaf652f.mp4";